
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/d1d4d1d98f921bfbe44a3929b6c7469c.png',
      title: 'Elegant Design',
      subtitle: 'Crafting Beautiful Experiences'
    },
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/f6f8eaaaa40702020a21ed1f645d562e.png',
      title: 'Modern Innovation',
      subtitle: 'Pushing Boundaries Forward'
    },
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/2d2ef379ad638200449b02b4aaf6c199.png',
      title: 'Creative Solutions',
      subtitle: 'Transforming Ideas into Reality'
    },
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/b272d27c32cda80e1cf7913228c13f49.png',
      title: 'Timeless Quality',
      subtitle: 'Excellence in Every Detail'
    },
    {
      image: 'https://static.readdy.ai/image/c38ca4b43662e8df5be3570b092391f1/1b094aac01704f23a44f90266c1b9c22.png',
      title: 'Inspired Living',
      subtitle: 'Design That Moves You'
    }
  ];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5_000);

    return () => clearInterval(slideInterval);
  }, [slides.length]);

  return (
    <section 
      id="home" 
      className="min-h-screen flex flex-col relative overflow-hidden"
    >
      {/* メイン画像セクション */}
      <div className="flex-1 relative">
        {/* スライドショー背景 */}
        <div className="absolute inset-0">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-[3000ms] ease-in-out ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              {/* 背景画像 - スマホでは全体表示、PCではカバー表示 */}
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage: `url('${slide.image}')`,
                  backgroundSize: window.innerWidth < 768 ? '150%' : 'cover',
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat'
                }}
              />
            </div>
          ))}
        </div>

        {/* スライドインジケーター */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-30">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-500 cursor-pointer ${
                index === currentSlide 
                  ? 'bg-stone-600 scale-110' 
                  : 'bg-stone-400/50 hover:bg-stone-500/70'
              }`}
            />
          ))}
        </div>
      </div>

      {/* テキストセクション(画像の下) */}
      <div className="py-16 px-4 bg-white relative z-30">
        <div className="container mx-auto text-center">
          <div className={`transition-all duration-[2500ms] ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-light mb-6 leading-tight tracking-wide text-stone-700">
              <div className={`transition-all duration-[2000ms] ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`} style={{ transitionDelay: '800ms' }}>
                {t('hero.title')}
              </div>
              <div className={`transition-all duration-[2000ms] ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`} style={{ transitionDelay: '1200ms' }}>
                Knit Design
              </div>
            </h1>
            
            <div className={`transition-all duration-[2000ms] ease-out ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`} style={{ transitionDelay: '1600ms' }}>
              <p className="text-lg md:text-xl text-stone-500 leading-relaxed font-medium tracking-wider">
                {t('hero.subtitle')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
